import { createContext, ReactNode } from 'react';

export interface FeatureFlags {
  DISABLE_SPA_NAVIGATION: boolean;
}

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined);

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags: FeatureFlags;
}

export function FeatureFlagsProvider({ children, flags }: FeatureFlagsProviderProps) {
  return (
    <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
  );
}
